<!--
 * @ Author: Your name
 * @ Create Time: 2019-05-29 14:07:49
 * @ Modified by: Your name
 * @ Modified time: 2019-07-12 10:42:43
 * @ Description: 角色管理 弹窗
 -->
<template>
  <div class="dialog-wrapper">
    <el-form :model="dialogFormData" label-width="80px"
      label-position="right" ref="dialogForm" :rules='rules'
      v-loading="formLoading" class="dialog-form" :inline="true">
      <el-row :gutter="10">
        <el-col :span="12" class="cols">
          <el-form-item label="角色名" prop="roleName">
            <el-input
              v-model="dialogFormData.roleName" size="small"
              placeholder="角色名" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12" class="cols">
          <el-form-item label="权限列表" prop="menuId" >
            <el-select v-model="dialogFormData.menuId"
              clearable placeholder="请选择" size="small" multiple filterable>
              <el-option
                v-for="item in menuIdList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import dialog from '../../mixins/dialog'
import { ROLE_MANAGE } from '../../libs/api'

export default {
  mixins: [dialog],
  data() {
    return {
      formLoading: false,
      dialogFormData: {
        roleName: '',
        menuId: ''
      },
      rules: {
        roleName: { required: true, message: '请输入角色名', trigger: ['change'] },
        menuId: { required: true, message: '请选择权限列表', trigger: ['change'] }
      },
      editUrl: ROLE_MANAGE.EDIT_LIST, // 修改路径
      UNPACKLOGID: '4', // 开箱日志 权限id
      DOORMANAGE: '5' // 柜门管理 权限id
    }
  },
  computed: {
    menuIdList() {
      // 隐藏 "柜门管理" 和 "开箱日志"
      let temp = this.dic.menuId.filter(element => {
        const val = element.value !== this.UNPACKLOGID && element.value !== this.DOORMANAGE
        return val
      })
      // 菜单名按id 排序
      temp = temp.sort((a, b) => a.value - b.value)
      return temp
    }
  },
  mounted() {
    this.$refs.dialogForm.resetFields()
  },
  methods: {
    initDialogFormdata() { // 初始化弹窗数据
      const { menuName, roleName } = this.dic.initDialogData
      const data = roleName.split(',')
      this.dialogFormData = {
        roleName: data[0],
        roleNameId: data[1],
        menuId: menuName.map(item => item.split(',')[1])
      }
    }
  }
}
</script>
